import { createContext } from 'react';

// SYNC THESE TWO IDS WITH DATABASE
export const TEMPLATES_IDS = {
  demo: 'demo-id',
  blank: 'blank-id',
};

export const TinyToolbarContainerProps = {
  id: 'fixed-toolbar-container',
  height: '40px',
};

export const DOM_LAYOUT_ROOT_BLOCK_ID = 'quillbot-application-layout';

export const LAYOUT_VARS = {
  bannerHeight: '--co-writer-banner-height',
  maintenanceHeight: '--co-writer-maintenance-height',
  headerPaddingX: '--co-writer-header-padding-x',
  headerPaddingY: '--co-writer-header-padding-y',
  headerHeight: '--co-writer-header-height',
  logoBrandSize: '--co-writer-logo-brand-size',
  menubarHeight: '--co-writer-menubar-height',
  toolbarHeight: '--co-writer-toolbar-height',
  drawerWidth: '--co-writer-drawer-width',
  drawerMenubarHeight: '--co-writer-drawer-menubar-height',
};

export const LAYOUT_VALS = {
  bannerHeight: `var(${LAYOUT_VARS.bannerHeight}, 0px)`,
  maintenanceHeight: `var(${LAYOUT_VARS.maintenanceHeight})`,
  headerPaddingX: `var(${LAYOUT_VARS.headerPaddingX})`,
  headerPaddingY: `var(${LAYOUT_VARS.headerPaddingY})`,
  headerHeight: `var(${LAYOUT_VARS.headerHeight})`,
  logoBrandSize: `var(${LAYOUT_VARS.logoBrandSize})`,
  drawerMenubarHeight: `var(${LAYOUT_VARS.drawerMenubarHeight})`,
  menubarHeight: `var(${LAYOUT_VARS.menubarHeight})`,
  toolbarHeight: `var(${LAYOUT_VARS.toolbarHeight})`,
  drawerWidth: `var(${LAYOUT_VARS.drawerWidth})`,
  fileMenuShift: `calc(var(${LAYOUT_VARS.logoBrandSize}) + 8px)`,
  drawerHeight: `calc(100vh - var(${LAYOUT_VARS.menubarHeight}))`,
  // ! a offset of 2px is for safeguarding
  // ! callee must be aware of this
  contentHeight: `calc(100vh - var(${LAYOUT_VARS.maintenanceHeight}) - var(${LAYOUT_VARS.bannerHeight}) - var(${LAYOUT_VARS.headerHeight}))`,
  contentWidth: '100%',
  mainContainerWidth: `calc(100% - var(${LAYOUT_VARS.drawerWidth}))`,
};

export const LAYOUT_CLASSES = {
  layout: 'layout',
  layoutCoWriter: 'layout--coWriter',
  withMaintenanceBar: 'layout--maintenance-bar',
};

export const PROJECT_TITLE_REGEX = /^[\w\s]*$/;
export const PROJECT_TITLE_MAX_LENGTH = 200;
export const DEFAULT_PROJECT_TITLE = 'Untitled project';
export const DEMO_PROJECT_TITLE = 'Features (Demo)';
export const DEMO_PROJECT_TARGET_TEXT_ID = 'co-writer-demo-project-target-text-id';
export const DEMO_PROJECT_HTML = `<p class="root-block-node" data-changed="true" data-paragraphid="1"><span style="font-family: helvetica, arial, sans-serif; font-size: 30px; color: #499557;" data-mce-style="font-family: helvetica, arial, sans-serif; font-size: 30px; color: #499557;"><strong>Intro</strong></span></p><p id="${DEMO_PROJECT_TARGET_TEXT_ID}" class="root-block-node" data-changed="true" data-paragraphid="2"><span style="color: #505050; font-size: 16px;" data-mce-style="color: #505050; font-size: 16px;">Co-Writer is an all-in-one writing tool that allows you to paraphrase, grammar check, <span style="font-family: helvetica, arial, sans-serif;" data-mce-style="font-family: helvetica, arial, sans-serif;">get writing tips</span>, and even search the web without switching between tabs.</span></p><p class="root-block-node" data-changed="true" data-paragraphid="3"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="4"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="5"><span style="color: #499557;" data-mce-style="color: #499557;"><strong><span style="font-size: 30px; background-color: #ffffff; font-family: helvetica, arial, sans-serif;" data-mce-style="font-size: 30px; background-color: #ffffff; font-family: helvetica, arial, sans-serif;">Feature List</span></strong></span></p><ul class="root-block-node" data-changed="true" data-paragraphid="6"><li><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><strong><span style="color: #499557;" data-mce-style="color: #499557;"><span style="color: #505050;" data-mce-style="color: #505050;">Research:</span> </span></strong><span style="font-size: 14px; color: #252525;" data-mce-style="font-size: 14px; color: #252525;">You can search for content on the right-hand side, <span style="background-color: #ffffff;" data-mce-style="background-color: #ffffff;">highlight the text</span><span style="background-color: #ffffff;" data-mce-style="background-color: #ffffff;">,</span> and insert it here.</span></span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="7"><li class="root-block-node" style="line-height: 1.5;" data-paragraphid="77" data-from-init="true" data-changed="true" data-mce-style="line-height: 1.5;"><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><strong><span style="color: #505050;" data-mce-style="color: #505050;">Write Assist: </span></strong><span style="font-size: 14px; color: #252525;" data-mce-style="font-size: 14px; color: #252525;">Get content suggestions by right clicking or using the shortcut Ctrl + Space (Win) or Ctrl + Shift + Spacebar (Mac).</span></span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="8"><li class="root-block-node" style="line-height: 1.5;" data-paragraphid="120" data-from-init="true" data-changed="true" data-mce-style="line-height: 1.5;"><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><span style="color: #505050;" data-mce-style="color: #505050;"><strong><span data-startindex="0" data-endindex="11" data-paragraphid="793"><span data-startindex="0" data-endindex="11" data-paragraphid="456"><span data-startindex="0" data-endindex="11" data-paragraphid="36"><span data-startindex="0" data-endindex="11" data-paragraphid="120"><span data-startindex="0" data-endindex="11" data-paragraphid="120"><span data-startindex="0" data-endindex="11" data-paragraphid="36"><span data-startindex="0" data-endindex="11" data-paragraphid="120"><span><span>Paraphrase: </span></span></span></span></span></span></span></span></span></strong></span></span><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><span style="font-size: 14px; color: #252525;" data-mce-style="font-size: 14px; color: #252525;">Highlight your text and right-click it to paraphrase it.</span></span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="9"><li><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><strong><span style="color: #505050;" data-mce-style="color: #505050;">Grammar Check:</span> </strong><span style="font-size: 14px;" data-mce-style="font-size: 14px;">Fix all grammar errors at once by clicking on the "Fix All Errors" button on the bottom right.</span></span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="10"><li class="root-block-node" style="line-height: 1.5;" data-paragraphid="120" data-from-init="true" data-changed="true" data-mce-style="line-height: 1.5;"><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><strong><span style="color: #505050;" data-mce-style="color: #505050;">Cloud Storage:</span> </strong><span style="font-size: 14px;" data-mce-style="font-size: 14px;">All your projects are saved directly in the Co-Writer. Click on "Open" to create a new or access existing projects.</span></span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="11"><li><strong><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><span style="color: #499557;" data-mce-style="color: #499557;"><span style="color: #505050;" data-mce-style="color: #505050;"><span data-startindex="0" data-endindex="9" data-paragraphid="796"><span data-startindex="0" data-endindex="9" data-paragraphid="459"><span data-startindex="0" data-endindex="9" data-paragraphid="39"><span data-startindex="0" data-endindex="9" data-paragraphid="39"><span data-startindex="0" data-endindex="9" data-paragraphid="42"><span><span>Notebook: </span></span></span></span></span></span></span></span></span></span></strong><span style="font-size: 14px;" data-mce-style="font-size: 14px;">You can jot down your ideas or rough work in the notebook section. Also, bookmarks from the research tab are shown here.</span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="12"><li class="root-block-node" style="line-height: 1.5;" data-paragraphid="120" data-from-init="true" data-changed="true" data-mce-style="line-height: 1.5;"><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><span style="color: #505050;" data-mce-style="color: #505050;"><strong><span data-startindex="0" data-endindex="10" data-paragraphid="797"><span data-startindex="0" data-endindex="10" data-paragraphid="460"><span data-startindex="0" data-endindex="10" data-paragraphid="40"><span data-startindex="0" data-endindex="10" data-paragraphid="120"><span data-startindex="0" data-endindex="10" data-paragraphid="43"><span><span>Analytics: </span></span></span></span></span></span></span></strong></span><span style="font-size: 14px;" data-mce-style="font-size: 14px;">This tab tells you how your content sounds and gives you important stats like reading time, etc.</span></span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="13"><li><strong><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><span data-startindex="0" data-endindex="10" data-paragraphid="364"><span style="color: #499557;" data-mce-style="color: #499557;"><span style="color: #505050;" data-mce-style="color: #505050;"><span data-startindex="0" data-endindex="10" data-paragraphid="798"><span data-startindex="0" data-endindex="10" data-paragraphid="461"><span data-startindex="0" data-endindex="10" data-paragraphid="41"><span data-startindex="0" data-endindex="10" data-paragraphid="41"><span data-startindex="0" data-endindex="10" data-paragraphid="44"><span><span>Citations: </span></span></span></span></span></span></span></span></span></span></span></strong><span style="font-size: 14px;" data-mce-style="font-size: 14px;">You can add your citations here and choose the citation style of your choice.&nbsp;</span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="14"><li class="root-block-node" style="line-height: 1.5;" data-paragraphid="120" data-from-init="true" data-changed="true" data-mce-style="line-height: 1.5;"><span style="font-size: 16px;" data-mce-style="font-size: 16px;"><strong><span data-startindex="0" data-endindex="17" data-paragraphid="365"><span style="color: #499557;" data-mce-style="color: #499557;"><span style="color: #505050;" data-mce-style="color: #505050;"><span data-startindex="0" data-endindex="17" data-paragraphid="799"><span data-startindex="0" data-endindex="17" data-paragraphid="462"><span data-startindex="0" data-endindex="8" data-paragraphid="42"><span data-startindex="0" data-endindex="8" data-paragraphid="120"><span data-startindex="0" data-endindex="8" data-paragraphid="45"><span><span>Dictate: </span></span></span></span></span></span></span></span></span></span></strong><span style="color: #499557; font-size: 14px;" data-mce-style="color: #499557; font-size: 14px;"><span style="color: #252525;" data-mce-style="color: #252525;">You can voice-type your thoughts by selecting "Dictate" on the bottom right.</span></span></span></li></ul><ul class="root-block-node" data-changed="true" data-paragraphid="15"><li><em><span style="color: #505050;" data-mce-style="color: #505050;"><strong><span style="font-size: 16px;" data-mce-style="font-size: 16px;">And many more.</span></strong></span></em></li></ul><p class="root-block-node" data-changed="true" data-paragraphid="16"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="17" data-from-init="true"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="18"><span style="color: #499557; font-size: 24px;" data-mce-style="color: #499557; font-size: 24px;"><strong><span style="font-family: helvetica, arial, sans-serif;" data-mce-style="font-family: helvetica, arial, sans-serif;">Got some feedback for us?</span></strong></span></p><p class="root-block-node" data-changed="true" data-paragraphid="19"><span style="font-size: 16px;" data-mce-style="font-size: 16px;">Click on the Feedback button at the end of the top toolbar and let us know.</span></p><p class="root-block-node" data-changed="true" data-paragraphid="20"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="21" data-from-init="true"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="22" data-from-init="true"><br></p><p class="root-block-node" style="text-align: center;" data-changed="true" data-paragraphid="23" data-mce-style="text-align: center;"><span style="background-color: #ffffff; font-size: 16px;" data-mce-style="background-color: #ffffff; font-size: 16px;">"We're constantly working hard on making this app better and </span><span style="background-color: #ffffff; font-size: 16px;" data-mce-style="background-color: #ffffff; font-size: 16px;">more useful for you."</span></p><p class="root-block-node" style="text-align: center;" data-changed="true" data-paragraphid="24" data-mce-style="text-align: center;"><span style="background-color: #ffffff;" data-mce-style="background-color: #ffffff;"><strong><span style="font-size: 16px; background-color: #ffffff;" data-mce-style="font-size: 16px; background-color: #ffffff;"><em>-Co-Writer team</em></span></strong></span></p><p class="root-block-node" data-changed="true" data-paragraphid="25"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="26"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="27"><br></p><p class="root-block-node" data-changed="true" data-paragraphid="28"><br></p>`;
export const DEFAULT_EDITOR_HTML = '<p></p>';
export const ONE_KB = 1024;
export const ONE_MB = 1024 * ONE_KB;

export enum StorageLevelEnum {
  NORMAL = 'normal', // < 80
  INFO = 'info', // 80-90
  WARNING = 'warning', // 90-95
  DANGER = 'danger', // 95-99
  CRITICAL = 'critical', // >99
}

export const DOM_PROJECT_TITLE_INPUT_ID = 'project-title-input';
export const DOM_PROJECT_TITLE_INPUT_SKELETON_ID = 'project-title-input-skeleton';
export const DOM_RESEARCH_SEARCH_BOX_ID = 'research-search-box';
export const RESEARCH_OVERFLOW_ID = 'botttom-scroll-bar';
export const EDITOR_OVERFLOW_ID = 'left-pane-overflow';
export const DOM_TOOL_PANE_ID = 'main-toolpane';
export const EDITOR_TOOLBAR_ID = 'fixed-toolbar-container';
export const MAIN_EDITOR_ID = 'main-editor';
export const DOM_EDITOR_PLACEHOLDER_ID = 'editor-placeholder';
export const DOM_RESEARCH_EDITOR_ID = 'writer-pane-container';
export const DOM_RESEARCH_MASTER_ID = 'master-topic-container';
export const DOM_RESEARCH_CONTENT_ID = 'research-content';
export const DOM_TOOLBAR_SKELETON_ID = 'toolbar-skeleton';
export const DOM_MENU_TOOL_BAR_CONTAINER_ID = 'menu-tool-bar-container';
export const TOOL_PANE_TAB_HEIGHT = 50;
export const APP_BAR_HEIGHT = 50;
export const RESEARCH_SUB_TAB_HEIGHT = 120;
export const NOTEBOOK_SUB_TAB_HEIGHT = 30;
export const TOOLPANE_SIDEBAR_WIDTH = 400;

export const InlineSuggestionId = 'inlineSuggestion';
export const SuggestionLoaderId = 'suggestionLoader';
export const CitationLoaderId = 'citationLoader';
export const TempElemAttrSuffix = '__loading_async_append';
export const AttrDataTempElem = 'data-async-container';
export const AttrDataRefLoader = 'data-ref-loader';
export const CitationSpanClassName = 'CitationStyle';
export const CitationLoaderAnimationClass = 'pulseLoader';
export const GcErrorContainer = 'appendRedUnderline';

export const SCROLL_DOWN_TOOLTIP_CLOSED_COUNT_ID = 'SCROLL_DOWN_TOOLTIP_CLOSED_COUNT_ID';
export const SCROLL_DOWN_TO_BIBLIOGRAPHY_BUTTON = 'SCROLL_DOWN_TO_BIBLIOGRAPHY_BUTTON';
export const BIBLIOGRAPHY_PAGE_ID = 'BIBLIOGRAPHY_PAGE_ID';

export const writerSliderValues = {
  min: 1,
  max: 4,
  marks: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
};

export const MaxAutocompleteAllowed = {
  perMinute: 3,
  perHour: 25,
};

export const OverviewTextCharLimit = 155;

export const GrammarCheckerRequestBatchSize = 3;

export const MinimumWebSearchLength = 3;

export const undoTimeInMilliSecondsForProjectDeletion = 3000;

export const timeChunkInMilliSecondsToDivideForProjectDeletion = 100;

export const numberOfPreTextSentences = 4;

export const numberOfPostTextSentences = 2;

export const HeadingStyle = 'style="font-size:14px;font-weight: 700;"';

export const TextStyle = 'style="font-size:14px;font-weight: 400;"';

export const PrintingIFrame = 'printing-iframe';

export const ElementsToSkipForParaphraserAndSummarizer = [
  'span[data-ref]',
  '#inlineSuggestion',
  `[${AttrDataTempElem}]`,
  `[${AttrDataRefLoader}]`,
];

export const ElementsToSkipForGrammarChecker = ['#inlineSuggestion', `[${AttrDataTempElem}]`];

export const ElementsToSkipForSaving = [
  `#${InlineSuggestionId}`,
  `#${SuggestionLoaderId}`,
  `#${CitationLoaderId}`,
  `[${AttrDataTempElem}]`,
  `[${AttrDataRefLoader}]`,
];

export const DefaultRibbonPosition = {
  X: 100,
  Y: 120,
  ApproximateGrownWidth: 230,
  TopThresholdForShowingRibbon: -10,
  BottomThresholdForShowingRibbon: 130,
};

export const ContextMenuOffset = {
  X: 25,
  Y: 20,
  TOP: 40,
  BOTTOM: 40,
};

export const MenuWordLimit = {
  Menu: 1,
  Summarizer: 15,
  SuggestContent: 3,
  AddCitation: 3,
  Default: 3,
  Paraphraser: 1,
};

export const KEYS = {
  LOCALSTORAGE_HTML: 'cowriterHTML',
  LOCALSTORAGE_SCRATCHPAD: 'cowriterScratchPad',
  LOCALSTORAGE_PARAGRAPHID_COUNT: '1',
  LOCALSTORAGE_PROJECT_ID: 'cowriterProjectId',
  COWRITER_HAS_PREV_ONBOARDED: 'cowriterHasPrevOnboarded',
  LOCALSTORAGE_DONT_SHOW_STORAGE_BAR: 'cowriterDontShowStorageBar',
  LOCALSTORAGE_NEVER_SHOW_DOWNVOTE_DRAWER: 'neverShowDownVoteDrawer',
  LOCALSTORAGE_NEVER_ASK_DELETE_PROJECT: 'cowriterNeverAskDeleteProject',
  LOCALSTORAGE_PROJECT_CREATION_FAILED: 'cowriterProjectCreationFailed',
  LOCALSTORAGE_WA_ENCOURAGEMENT_TOOLTIP_COUNT: 'cowriterWaEncouragementTooltipCount',
  LOCALSTORAGE_WA_SHOW_INFORMATION_MODAL: 'cowriterWaShowInformationModal',
  LOCALSTORAGE_GC_SHOWN_INFORMATION_MODAL: 'cowriterGcShownInformationModal',
  LOCALSTORAGE_GC_PAINT_RESPONSE: 'cowriterGcPaintResponse',
  LOCAL_STORAGE_LIST_GRID_VIEW: 'cowriterListOrGridView',
  LOCAL_STORAGE_ANIMATION_ONBOARDING: 'cowriterAnimationOnboarding',
};

export const AlphabetRegex = /[a-zA-Z0-9]/gm;

export const GET_PROJECTS_API_LIMIT = 30;

export const WRAP_CHIPS_MAX_TOPIC_COUNT = 4;
export const TOPIC_CHIP_ALL = 'SHOW_ALL_TOPICS';
// Storage limit in MB
export const STORAGE_LIMIT = {
  free: 2,
  premium: 20,
};

export const DefaultHighlightsCountToShow = 2;

export const ONBOARDING = {
  IDS: {
    SEARCH_ICON: 'search-icon',
    SEARCH_BAR: 'search-bar',
    CONTEXT_MENU: 'context-menu',
    CONTEXT_MENU_PARAPHRASE_BUTTON: 'context-menu-paraphrase-button',
    CONTEXT_MENU_INSERT_BUTTON: 'context-menu-insert-button',
    CONTEXT_MENU_WRITE_ASSIST_BUTTON: 'context-menu-write-assist-button',
    MORE_ICON: 'more-icon',
    PROJECT_OPEN_ICON: 'project-open-icon',
    DEMO_PROJECT_TARGET_TEXT_ID,
  },
  CLASSES: {
    PULL_SOURCE_BUTTON: 'pull-source-button',
    OVERVIEW_TEXT: 'overview-text',
    EDITOR_PARAGRAPH: 'root-block-node',
    INSERTED_PARAGRAPH: 'inserted-paragraph',
  },
  DEFAULT_SEARCH_QUERY: 'benefits of yoga',
};

export enum KeyboardKeys {
  Enter = 'Enter',
  Delete = 'Delete',
  Tab = 'Tab',
  Escape = 'Escape',
  Backspace = 'Backspace',
  Space = ' ',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  A = 'A',
  V = 'V',
  v = 'v',
  a = 'a',
  C = 'C',
  c = 'c',
  P = 'P',
  p = 'p',

  /*   One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
  Seven = 7,
  Eight = 8,
  Nine = 9,
  Zero = 0,
  Q = 'Q',
  W = 'W',
  E = 'E',
  R = 'R',
  T = 'T',
  Y = 'Y',
  U = 'U',
  I = 'I',
  O = 'O',
  A = 'A',
  S = 'S',
  D = 'D',
  F = 'F',
  G = 'G',
  J = 'J',
  K = 'K',
  L = 'L',
  Z = 'Z',
  X = 'X',
  B = 'B',
  N = 'N',
  M = 'M',
  q = 'q',
  w = 'w',
  e = 'e',
  r = 'r',
  t = 't',
  y = 'y',
  u = 'u',
  i = 'i',
  o = 'o',
  s = 's',
  d = 'd',
  f = 'f',
  h = 'h',
  j = 'j',
  k = 'k',
  l = 'l',
  z = 'z',
  x = 'x',
  b = 'b',
  n = 'n',
  m = 'm',
  Unidentified = 'Unidentified',
  Alt = 'Alt',
  AltGraph = 'AltGraph',
  CapsLock = 'CapsLock',
  Control = 'Control',
  Fn = 'Fn',
  FnLock = 'FnLock',
  Hyper = 'Hyper',
  Meta = 'Meta',
  NumLock = 'NumLock',
  ScrollLock = 'ScrollLock',
  Shift = 'Shift',
  Super = 'Super',
  Symbol = 'Symbol',
  SymbolLock = 'SymbolLock',
  End = 'End',
  Home = 'Home',
  PageDown = 'PageDown',
  PageUp = 'PageUp',
  Clear = 'Clear',
  Copy = 'Copy',
  CrSel = 'CrSel',
  Cut = 'Cut',
  EraseEof = 'EraseEof',
  ExSel = 'ExSel',
  Insert = 'Insert',
  Paste = 'Paste',
  Redo = 'Redo',
  Undo = 'Undo',
  Accept = 'Accept',
  Again = 'Again',
  Attn = 'Attn',
  Cancel = 'Cancel',
  ContextMenu = 'ContextMenu',
  Execute = 'Execute',
  Find = 'Find',
  Finish = 'Finish',
  Help = 'Help',
  Pause = 'Pause',
  Play = 'Play',
  Props = 'Props',
  Select = 'Select',
  ZoomIn = 'ZoomIn',
  ZoomOut = 'ZoomOut',
  BrightnessDown = 'BrightnessDown',
  BrightnessUp = 'BrightnessUp',
  Eject = 'Eject',
  LogOff = 'LogOff',
  Power = 'Power',
  PowerOff = 'PowerOff',
  PrintScreen = 'PrintScreen',
  Hibernate = 'Hibernate',
  Standby = 'Standby',
  WakeUp = 'WakeUp',
  AllCandidates = 'AllCandidates',
  Alphanumeric = 'Alphanumeric',
  CodeInput = 'CodeInput',
  Compose = 'Compose',
  Convert = 'Convert',
  Dead = 'Dead',
  FinalMode = 'FinalMode',
  GroupFirst = 'GroupFirst',
  GroupLast = 'GroupLast',
  GroupNext = 'GroupNext',
  GroupPrevious = 'GroupPrevious',
  ModeChange = 'ModeChange',
  NextCandidate = 'NextCandidate',
  NonConvert = 'NonConvert',
  PreviousCandidate = 'PreviousCandidate',
  Process = 'Process',
  SingleCandidate = 'SingleCandidate',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  F13 = 'F13',
  F14 = 'F14',
  F15 = 'F15',
  F16 = 'F16',
  F17 = 'F17',
  F18 = 'F18',
  F19 = 'F19',
  F20 = 'F20',
  Soft1 = 'Soft1',
  Soft2 = 'Soft2',
  Soft3 = 'Soft3',
  Soft4 = 'Soft4',
  AppSwitch = 'AppSwitch',
  Call = 'Call',
  Camera = 'Camera',
  CameraFocus = 'CameraFocus',
  EndCall = 'EndCall',
  GoBack = 'GoBack',
  GoHome = 'GoHome',
  HeadsetHook = 'HeadsetHook',
  LastNumberRedial = 'LastNumberRedial',
  Notification = 'Notification',
  MannerMode = 'MannerMode',
  VoiceDial = 'VoiceDial',
  ChannelDown = 'ChannelDown',
  ChannelUp = 'ChannelUp',
  MediaFastForward = 'MediaFastForward',
  MediaPause = 'MediaPause',
  MediaPlay = 'MediaPlay',
  MediaPlayPause = 'MediaPlayPause',
  MediaRecord = 'MediaRecord',
  MediaRewind = 'MediaRewind',
  MediaStop = 'MediaStop',
  MediaTrackNext = 'MediaTrackNext',
  MediaTrackPrevious = 'MediaTrackPrevious',
  AudioBalanceLeft = 'AudioBalanceLeft',
  AudioBalanceRight = 'AudioBalanceRight',
  AudioBassDown = 'AudioBassDown',
  AudioBassBoostDown = 'AudioBassBoostDown',
  AudioBassBoostToggle = 'AudioBassBoostToggle',
  AudioBassBoostUp = 'AudioBassBoostUp',
  AudioBassUp = 'AudioBassUp',
  AudioFaderFront = 'AudioFaderFront',
  AudioFaderRear = 'AudioFaderRear',
  AudioSurroundModeNext = 'AudioSurroundModeNext',
  AudioTrebleDown = 'AudioTrebleDown',
  AudioTrebleUp = 'AudioTrebleUp',
  AudioVolumeDown = 'AudioVolumeDown',
  AudioVolumeMute = 'AudioVolumeMute',
  AudioVolumeUp = 'AudioVolumeUp',
  MicrophoneToggle = 'MicrophoneToggle',
  MicrophoneVolumeDown = 'MicrophoneVolumeDown',
  MicrophoneVolumeMute = 'MicrophoneVolumeMute',
  MicrophoneVolumeUp = 'MicrophoneVolumeUp',
  AVRInput = 'AVRInput',
  AVRPower = 'AVRPower',
  ColorF0Red = 'ColorF0Red',
  ColorF1Green = 'ColorF1Green',
  ColorF2Yellow = 'ColorF2Yellow',
  ColorF3Blue = 'ColorF3Blue',
  ColorF4Grey = 'ColorF4Grey',
  ColorF5Brown = 'ColorF5Brown',
  ClosedCaptionToggle = 'ClosedCaptionToggle',
  Dimmer = 'Dimmer',
  DisplaySwap = 'DisplaySwap',
  DVR = 'DVR',
  Exit = 'Exit',
  FavoriteClear0 = 'FavoriteClear0',
  FavoriteClear1 = 'FavoriteClear1',
  FavoriteClear2 = 'FavoriteClear2',
  FavoriteClear3 = 'FavoriteClear3',
  FavoriteRecall0 = 'FavoriteRecall0',
  FavoriteRecall1 = 'FavoriteRecall1',
  FavoriteRecall2 = 'FavoriteRecall2',
  FavoriteRecall3 = 'FavoriteRecall3',
  FavoriteStore0 = 'FavoriteStore0',
  FavoriteStore1 = 'FavoriteStore1',
  FavoriteStore2 = 'FavoriteStore2',
  FavoriteStore3 = 'FavoriteStore3',
  Guide = 'Guide',
  GuideNextDay = 'GuideNextDay',
  GuidePreviousDay = 'GuidePreviousDay',
  Info = 'Info',
  InstantReplay = 'InstantReplay',
  Link = 'Link',
  ListProgram = 'ListProgram',
  LiveContent = 'LiveContent',
  Lock = 'Lock',
  MediaApps = 'MediaApps',
  MediaAudioTrack = 'MediaAudioTrack',
  MediaLast = 'MediaLast',
  MediaSkipBackward = 'MediaSkipBackward',
  MediaSkipForward = 'MediaSkipForward',
  MediaStepBackward = 'MediaStepBackward',
  MediaStepForward = 'MediaStepForward',
  MediaTopMenu = 'MediaTopMenu',
  NavigateIn = 'NavigateIn',
  NavigateNext = 'NavigateNext',
  NavigateOut = 'NavigateOut',
  NavigatePrevious = 'NavigatePrevious',
  NextFavoriteChannel = 'NextFavoriteChannel',
  NextUserProfile = 'NextUserProfile',
  OnDemand = 'OnDemand',
  Pairing = 'Pairing',
  PinPDown = 'PinPDown',
  PinPMove = 'PinPMove',
  PinPToggle = 'PinPToggle',
  PinPUp = 'PinPUp',
  PlaySpeedDown = 'PlaySpeedDown',
  PlaySpeedReset = 'PlaySpeedReset',
  PlaySpeedUp = 'PlaySpeedUp',
  RandomToggle = 'RandomToggle',
  RcLowBattery = 'RcLowBattery',
  RecordSpeedNext = 'RecordSpeedNext',
  RfBypass = 'RfBypass',
  ScanChannelsToggle = 'ScanChannelsToggle',
  ScreenModeNext = 'ScreenModeNext',
  Settings = 'Settings',
  SplitScreenToggle = 'SplitScreenToggle',
  STBInput = 'STBInput',
  STBPower = 'STBPower',
  Subtitle = 'Subtitle',
  Teletext = 'Teletext',
  VideoModeNext = 'VideoModeNext',
  Wink = 'Wink',
  ZoomToggle = 'ZoomToggle',
  SpeechCorrectionList = 'SpeechCorrectionList',
  SpeechInputToggle = 'SpeechInputToggle',
  Close = 'Close',
  New = 'New',
  Open = 'Open',
  Print = 'Print',
  Save = 'Save',
  SpellCheck = 'SpellCheck',
  MailForward = 'MailForward',
  MailReply = 'MailReply',
  MailSend = 'MailSend',
  LaunchCalculator = 'LaunchCalculator',
  LaunchCalendar = 'LaunchCalendar',
  LaunchContacts = 'LaunchContacts',
  LaunchMail = 'LaunchMail',
  LaunchMediaPlayer = 'LaunchMediaPlayer',
  LaunchMusicPlayer = 'LaunchMusicPlayer',
  LaunchMyComputer = 'LaunchMyComputer',
  LaunchPhone = 'LaunchPhone',
  LaunchScreenSaver = 'LaunchScreenSaver',
  LaunchSpreadsheet = 'LaunchSpreadsheet',
  LaunchWebBrowser = 'LaunchWebBrowser',
  LaunchWebCam = 'LaunchWebCam',
  LaunchWordProcessor = 'LaunchWordProcessor',
  LaunchApplication1 = 'LaunchApplication1',
  LaunchApplication2 = 'LaunchApplication2',
  LaunchApplication3 = 'LaunchApplication3',
  LaunchApplication4 = 'LaunchApplication4',
  LaunchApplication5 = 'LaunchApplication5',
  LaunchApplication6 = 'LaunchApplication6',
  LaunchApplication7 = 'LaunchApplication7',
  LaunchApplication8 = 'LaunchApplication8',
  LaunchApplication9 = 'LaunchApplication9',
  LaunchApplication10 = 'LaunchApplication10',
  LaunchApplication11 = 'LaunchApplication11',
  LaunchApplication12 = 'LaunchApplication12',
  LaunchApplication13 = 'LaunchApplication13',
  LaunchApplication14 = 'LaunchApplication14',
  LaunchApplication15 = 'LaunchApplication15',
  LaunchApplication16 = 'LaunchApplication16',
  BrowserBack = 'BrowserBack',
  BrowserFavorites = 'BrowserFavorites',
  BrowserForward = 'BrowserForward',
  BrowserHome = 'BrowserHome',
  BrowserRefresh = 'BrowserRefresh',
  BrowserSearch = 'BrowserSearch',
  BrowserStop = 'BrowserStop',
  Decimal = 'Decimal',
  Key11 = 'Key11',
  Key12 = 'Key12',
  Multiply = 'Multiply',
  Add = 'Add',
  Divide = 'Divide',
  Subtract = 'Subtract',
  Separator = 'Separator', */
}

export const AREAP2 = 861696;

export const CoWriterGcIgnoreWords = [
  {
    word: 'Paraphrase: ',
    startIndex: 0,
    endIndex: 11,
    globalIgnore: false,
  },
  {
    word: 'Notebook: ',
    startIndex: 0,
    endIndex: 9,
    globalIgnore: false,
  },
  {
    word: 'Analytics: ',
    startIndex: 0,
    endIndex: 10,
    globalIgnore: false,
  },
  {
    word: 'Citations: ',
    startIndex: 0,
    endIndex: 10,
    globalIgnore: false,
  },
  {
    word: 'Dictate: ',
    startIndex: 0,
    endIndex: 8,
    globalIgnore: false,
  },
  // {
  //   word: 'aniket',
  //   startIndex: -1,
  //   endIndex: -1,
  //   globalIgnore: true,
  // },
];

export const Events = {
  ResizeCustomEvent: 'ResizeCustomEvent',
  RunGcCustomEvent: 'RunGcCustomEvent',
  RecomputeGcErrorsCustomEvent: 'RecomputeGcErrorsCustomEvent',
  FixAllGrammarErrorsCustomEvent: 'FixAllGrammarErrorsCustomEvents',
};

export const Space = ' ';

export const EmptyString = '';
